import React from 'react'
import { AccessTime, InfoOutlined, LocalShippingOutlined, LocationOnOutlined } from "@mui/icons-material";
import { Box, Grid } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { useTransshipmentDetailContext } from "contexts/TransshipmentDetailContext";

import { localizeDateTimeShort } from "utils/dateFormats";

const TransshipmentBasicDetail = () => {

  const { transshipmentDetail, loadingTransshipment } =
    useTransshipmentDetailContext();
  return !loadingTransshipment ? (
    <Box padding={3}>
      <Grid container spacing={4}>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Loading ID"
            subtitle={transshipmentDetail?.loadingId}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Collection ID"
            subtitle={
              transshipmentDetail?.shipmentId && typeof transshipmentDetail.shipmentId === "object"
                ? transshipmentDetail?.shipmentId?.shipmentId
                : transshipmentDetail?.shipmentId
            }
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocationOnOutlined color="primary" />}
            title="Loading Location"
            subtitle={`lat: ${transshipmentDetail?.loadingLocation?.lat},
           lon: ${transshipmentDetail?.loadingLocation?.lon}`}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocationOnOutlined color="primary" />}
            title="UnLoading Location"
            subtitle={`lat: ${transshipmentDetail?.unloadingLocation?.lat},
           lon: ${transshipmentDetail?.unloadingLocation?.lon}`}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <AccessTime color="primary" />}
            title="Loading Time"
            subtitle={localizeDateTimeShort(transshipmentDetail?.loadingTime)}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <AccessTime color="primary" />}
            title="UnLoading Time"
            subtitle={localizeDateTimeShort(transshipmentDetail?.unloadingTime)}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Cargo Type"
            subtitle={transshipmentDetail?.cargoType}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Cargo Condition"
            subtitle={transshipmentDetail?.cargoCondition}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="isActive"
          >
            <Status isActive={transshipmentDetail?.isActive} />
          </InformationTile>
        </Grid>

      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  )
}

export default TransshipmentBasicDetail;